<template>
	<div class="small-12 articleTitle flex justify-center animated fadeIn" v-if="policy">
        <h1>{{ policy.attributes.title }}</h1>
    </div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PolicyTitle',

		/*
		**  Set the props
		*/

		props: {

			policy: {
                type: Object,
                default: () => null
            }
    
		}

	}

</script>